import { createIntl, createIntlCache } from 'react-intl'

let intl

export const initIntl = (locale, messages) => {
  const cache = createIntlCache()
  intl = createIntl({ locale, messages }, cache)
}

export const getIntl = () => {
  if (!intl) {
    throw new Error('intl non inizializzato. Chiama initIntl(locale, messages) prima di usare getIntl().')
  }
  return intl
}